import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-body pt-6 pb-0" }
const _hoisted_3 = { class: "card-header border-0 pt-5" }
const _hoisted_4 = { class: "card-title align-items-center" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Monthly Prime Rank For This Year", -1)
const _hoisted_7 = { class: "card-body py-3" }
const _hoisted_8 = { class: "table-responsive d-none d-md-block" }
const _hoisted_9 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_10 = { class: "text-muted fw-semibold fs-8 text-uppercase" }
const _hoisted_11 = {
  key: 0,
  class: "seq-badge seq-badge--success"
}
const _hoisted_12 = {
  key: 0,
  class: "seq-badge seq-badge--danger"
}
const _hoisted_13 = { class: "table-responsive d-md-none" }
const _hoisted_14 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Month"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4 text-end" }, "Status")
  ])
], -1)
const _hoisted_16 = { class: "ps-4" }
const _hoisted_17 = { class: "fw-semibold text-gray-800" }
const _hoisted_18 = { class: "pe-4 text-end" }
const _hoisted_19 = {
  key: 0,
  class: "seq-badge seq-badge--success"
}
const _hoisted_20 = {
  key: 0,
  class: "seq-badge seq-badge--danger"
}
const _hoisted_21 = { class: "card-body py-3" }
const _hoisted_22 = { class: "row g-5" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "mb-0" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" As of now, you are qualified for the Prime position for the month of ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(". Keep it up! ")
const _hoisted_27 = { class: "mb-0" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" You are not yet qualified for the month of ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_30 = { class: "seq-prime-req mb-4" }
const _hoisted_31 = {
  key: 0,
  class: "material-icons"
}
const _hoisted_32 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fw-semibold text-gray-800" }, "Total prime requirements achieved.")
], -1)
const _hoisted_34 = { class: "seq-prime-req mb-4" }
const _hoisted_35 = {
  key: 0,
  class: "material-icons"
}
const _hoisted_36 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold text-gray-800" }, "Personal Consumption Done (PMA/PC)", -1)
const _hoisted_38 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_39 = { class: "seq-prime-req mb-4" }
const _hoisted_40 = {
  key: 0,
  class: "material-icons"
}
const _hoisted_41 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold text-gray-800" }, "Most Active Line Must Produce At Least 1 Point", -1)
const _hoisted_43 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_44 = { class: "seq-prime-req mb-4" }
const _hoisted_45 = {
  key: 0,
  class: "material-icons"
}
const _hoisted_46 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold text-gray-800" }, "Minimum of 2 Moving Legs / Directs", -1)
const _hoisted_48 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_49 = { class: "seq-prime-req mb-4" }
const _hoisted_50 = {
  key: 0,
  class: "material-icons"
}
const _hoisted_51 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold text-gray-800" }, " 10% Of The Total Monthly Production Coming From The Other Legs/ Directs. ", -1)
const _hoisted_53 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "table-responsive" }
const _hoisted_56 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_57 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "USID"),
    /*#__PURE__*/_createVNode("th", null, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "text-end pe-4" }, "Points")
  ])
], -1)
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/_createVNode("td", {
  colspan: "3",
  class: "text-center text-muted py-10"
}, "No moving legs found.", -1)
const _hoisted_60 = { class: "ps-4" }
const _hoisted_61 = { class: "d-flex align-items-center" }
const _hoisted_62 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_63 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_64 = { class: "fw-semibold text-gray-800" }
const _hoisted_65 = { class: "fw-semibold text-gray-800" }
const _hoisted_66 = { class: "text-end pe-4" }
const _hoisted_67 = { class: "fw-semibold seq-trend-up" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_DashboardTabNavigator = _resolveComponent("DashboardTabNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card mb-5"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DashboardTabNavigator)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("h3", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Star.svg" })
            ]),
            _hoisted_6
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("table", _hoisted_9, [
              _createVNode("thead", null, [
                _createVNode("tr", _hoisted_10, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rankPrimeOneYear, (item, index) => {
                    return (_openBlock(), _createBlock("th", {
                      key: index,
                      class: "ps-4"
                    }, _toDisplayString(item.month_abbrev), 1))
                  }), 128))
                ])
              ]),
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rankPrimeOneYear, (item, index) => {
                    return (_openBlock(), _createBlock("td", {
                      key: index,
                      class: "ps-4"
                    }, [
                      (item.primeRank != '')
                        ? (_openBlock(), _createBlock("span", _hoisted_11, "Done"))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            (item.ispast == 1)
                              ? (_openBlock(), _createBlock("span", _hoisted_12, "Missed"))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("table", _hoisted_14, [
              _hoisted_15,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rankPrimeOneYear, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", _hoisted_16, [
                      _createVNode("div", _hoisted_17, _toDisplayString(item.month_abbrev), 1)
                    ]),
                    _createVNode("td", _hoisted_18, [
                      (item.primeRank != '')
                        ? (_openBlock(), _createBlock("span", _hoisted_19, "Done"))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            (item.ispast == 1)
                              ? (_openBlock(), _createBlock("span", _hoisted_20, "Missed"))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2),
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              (_ctx.pm.isQualifiedPrimeNextMonth == 1)
                ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
                    key: 0,
                    variant: "success",
                    title: "Qualified",
                    class: "mb-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("p", _hoisted_24, [
                        _hoisted_25,
                        _createVNode("b", null, _toDisplayString(_ctx.nextMonth), 1),
                        _hoisted_26
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.pm.isQualifiedPrimeNextMonth != 1)
                ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
                    key: 1,
                    variant: "danger",
                    title: "Not yet qualified",
                    class: "mb-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("p", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("b", null, _toDisplayString(_ctx.nextMonth), 1),
                        _hoisted_29
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_30, [
                _createVNode("span", {
                  class: ["seq-prime-req__icon", _ctx.pm.isQualifiedPrimeNextMonth === 1 ? 'seq-prime-req__icon--ok' : 'seq-prime-req__icon--no']
                }, [
                  (_ctx.pm.isQualifiedPrimeNextMonth === 1)
                    ? (_openBlock(), _createBlock("i", _hoisted_31, "check_circle"))
                    : (_openBlock(), _createBlock("i", _hoisted_32, "cancel"))
                ], 2),
                _hoisted_33
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("span", {
                  class: ["seq-prime-req__icon", _ctx.pm.primeMonitoring_isPMA === 1 ? 'seq-prime-req__icon--ok' : 'seq-prime-req__icon--no']
                }, [
                  (_ctx.pm.primeMonitoring_isPMA === 1)
                    ? (_openBlock(), _createBlock("i", _hoisted_35, "check_circle"))
                    : (_openBlock(), _createBlock("i", _hoisted_36, "cancel"))
                ], 2),
                _createVNode("div", null, [
                  _hoisted_37,
                  (_ctx.pm.primeMonitoring_isPMA !== 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_38, " Buy and avail for your personal consumption products. "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_39, [
                _createVNode("span", {
                  class: ["seq-prime-req__icon", _ctx.pm.loop_topLeg_totalPoints >= 1.00 ? 'seq-prime-req__icon--ok' : 'seq-prime-req__icon--no']
                }, [
                  (_ctx.pm.loop_topLeg_totalPoints >= 1.00)
                    ? (_openBlock(), _createBlock("i", _hoisted_40, "check_circle"))
                    : (_openBlock(), _createBlock("i", _hoisted_41, "cancel"))
                ], 2),
                _createVNode("div", null, [
                  _hoisted_42,
                  (_ctx.pm.loop_topLeg_totalPoints < 1.00)
                    ? (_openBlock(), _createBlock("div", _hoisted_43, " Remind and encourage your other producing legs to buy and consume our products. "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_44, [
                _createVNode("span", {
                  class: ["seq-prime-req__icon", _ctx.pm.primeMonitoringSize >= 2 ? 'seq-prime-req__icon--ok' : 'seq-prime-req__icon--no']
                }, [
                  (_ctx.pm.primeMonitoringSize >= 2)
                    ? (_openBlock(), _createBlock("i", _hoisted_45, "check_circle"))
                    : (_openBlock(), _createBlock("i", _hoisted_46, "cancel"))
                ], 2),
                _createVNode("div", null, [
                  _hoisted_47,
                  (_ctx.pm.primeMonitoringSize < 2)
                    ? (_openBlock(), _createBlock("div", _hoisted_48, " Remind and encourage your other producing legs to buy and consume our products. "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode("span", {
                  class: ["seq-prime-req__icon", _ctx.pm.primeMonitoring_isOK == 1 ? 'seq-prime-req__icon--ok' : 'seq-prime-req__icon--no']
                }, [
                  (_ctx.pm.primeMonitoring_isOK == 1)
                    ? (_openBlock(), _createBlock("i", _hoisted_50, "check_circle"))
                    : (_openBlock(), _createBlock("i", _hoisted_51, "cancel"))
                ], 2),
                _createVNode("div", null, [
                  _hoisted_52,
                  (_ctx.pm.primeMonitoring_isOK != 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_53, " Remind and encourage your other producing legs to buy and consume our products. "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_54, [
              _createVNode("div", _hoisted_55, [
                _createVNode("table", _hoisted_56, [
                  _hoisted_57,
                  _createVNode("tbody", null, [
                    (!_ctx.pm.primeMonitoring || _ctx.pm.primeMonitoring.length === 0)
                      ? (_openBlock(), _createBlock("tr", _hoisted_58, [
                          _hoisted_59
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pm.primeMonitoring, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", _hoisted_60, [
                          _createVNode("div", _hoisted_61, [
                            _createVNode("span", _hoisted_62, [
                              _createVNode("span", _hoisted_63, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                              ])
                            ]),
                            _createVNode("div", _hoisted_64, _toDisplayString(item.usid), 1)
                          ])
                        ]),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_65, _toDisplayString(item.fullname), 1)
                        ]),
                        _createVNode("td", _hoisted_66, [
                          _createVNode("div", _hoisted_67, _toDisplayString(_ctx.numberWithCommas(item.totalpoints)), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, _ctx.isLoading == false]
    ])
  ], 64))
}